<template>
  <div class="animated fadeIn">
    <b-row>
      <b-col lg="12">
        <b-card no-body>
          <b-card-body>
            <template>
              <b-row>
                <b-col sm="3">
                  <b-form-group label-for="cro_listing" label="Daftar CRO">
                    <model-select
                      id="cro_listing"
                      :options="listCro"
                      v-model="cro"
                      placeholder="-- Harap pilih salah satu --"
                    ></model-select>
                    <div
                      v-if="cro === null"
                      class="invalid-feedback-custom"
                    >CRO harus di isi.</div>
                  </b-form-group>
                </b-col>
              </b-row>
            </template>
          </b-card-body>
        </b-card>
      </b-col>
    </b-row>
    <div class="card">
      <div class="card-header">Export Task CRO</div>
      <div v-if="loading == true">
        <loading></loading>
      </div>
      <div class="card-body" v-if="loading == false">
        <div class="col-lg-3">
          <b-button type="button" size="sm" variant="primary" @click="downloadfile">
            <i class="fa fa-save"></i> Download
          </b-button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import axios from "axios";
import loading from "@/templates/Loading.vue";
import { ModelSelect } from "vue-search-select";
import * as moment from "moment";

export default {
  name: "summary-sold-product",
  components: {
    loading,
    ModelSelect
  },
  data() {
    return {
      listCro: [],
      others: null,
      loading: false,
      cro: null,
      myDate: null,
      othersParam: null,
      dateType: null
    };
  },
  notifications: {
    showErrorNotification: {
      title: "Error Title",
      message: "Messages",
      type: "error"
    },
    showInfoNotification: {
      title: "Info Title",
      message: "Messages",
      type: "info"
    }
  },
  methods: {
    init: function() {
      this.loading = false;
      this.getAllOthers();
    },
    downloadfile: function() {
      if (confirm("Are You Sure?")) {
        //this.loading = true;
        if (this.cro === null) {
          alert("Filter harus di isi");
        } else {
          this.loading = true;

          this.axios({
            url:"web/export/cro/task-cro/"+this.cro,
            method: "GET",
            responseType: "blob"
          })
            .then(response => {
              const url = window.URL.createObjectURL(new Blob([response.data]));
              const link = document.createElement("a");
              link.href = url;
              link.setAttribute("download", "pembagian_tugas_cro.xlsx");
              document.body.appendChild(link);
              link.click();
            })
            .catch(error => {
              if (error.response.status === 401) {
                this.expired(error, "");
              }
            })
            .finally(() => {
              this.loading = false;
            });
        }
      }
    },
    getAllOthers: function() {
      this.axios
        .get("web/dropdown/task-cro/")
        .then(response => {
          this.listCro = [{'value': 'all', 'text': 'All'}];
          response.data.employee.forEach(o=>{
            this.listCro.push(o);
          });
          //this.listCro = response.data.employee;
        })
        .catch(error => {})
        .finally(() => {
          this.loading = false;
        });
    },
    expired: function(error, title) {
      if (error.response.status === 401) {
        localStorage.clear();
        this.$router.push({ path: "/login" });
        this.showErrorNotification({
          title: "Token Expired",
          message: "Your session has been expired"
        });
      } else {
        this.showErrorNotification({
          title: title,
          message: error.response.data.message
        });
      }
    }
  },
  mounted() {
    this.init();
  }
};
</script>

<style>
</style>
